"use strict";
exports.__esModule = true;
exports.parseBase64Uri = exports.getFileSizeDisplay = void 0;
var getFileSizeDisplay = function (bytes) {
    if (bytes < 1024) {
        return "".concat(bytes, " B");
    }
    else if (bytes <= 1024 * 1024) {
        return "".concat((bytes / 1024).toFixed(1), " KB");
    }
    else if (bytes <= 1024 * 1024 * 1024) {
        return "".concat((bytes / (1024 * 1024)).toFixed(1), " MB");
    }
    else {
        return "".concat((bytes / (1024 * 1024 * 1024)).toFixed(1), " GB");
    }
};
exports.getFileSizeDisplay = getFileSizeDisplay;
var parseBase64Uri = function (base64Uri) {
    var base64Parts = base64Uri.split(';base64,');
    var mimeType = base64Parts[0].replace('data:', '');
    return {
        base64Uri: base64Uri,
        base64: base64Parts[1],
        mimeType: mimeType
    };
};
exports.parseBase64Uri = parseBase64Uri;
